import { useQuery } from "@tanstack/react-query";
import { fetchIntegrationsData } from "@app/services/integrationsApi";
import type { IntegrationsPayload } from "@shared/types/integrations";

export const INTEGRATIONS_QUERY_KEY = ["dashboard", "integrations"] as const;

export function useIntegrationsData() {
  return useQuery<IntegrationsPayload>({
    queryKey: INTEGRATIONS_QUERY_KEY,
    queryFn: fetchIntegrationsData,
    staleTime: 2 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
    refetchInterval: false,
    refetchOnWindowFocus: false,
    retry: 1,
  });
}


